// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import type { RouterHistory, Match } from 'react-router-dom';
import { Box, InfiniteScroll } from 'grommet';
import GreenButton from 'esm-web-pro/components/layout/GreenButton';
import styled from 'styled-components';
import connectAPI from 'speed-js-react/src/api/connectAPI';
import type { ApiClient } from 'speed-js-core';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';
import { withRouter } from 'speed-js-react';
import * as sidePanelActions from 'esm-web-pro/redux/side-panel/actions';
import SidePane from 'esm-web-pro/components/layout/SidePane';


export const TimelineDelimiter = styled.div`
    &:before {
        content:"";
        display: flex;
        height: 0.4em;
        vertical-align: bottom;
        width: 100%;
        margin-right: -100%;
        margin-right: 8px;
        border-bottom: 1px solid grey;
    }
`;

type SidePanelActionProps = {
    openPanel: (key: string, url: ?string) => { key: string, url: string },
    closePanel: (key: string) => { key: string },
}

type Props = {
    ...$Exact<SidePanelActionProps>,
    getData?: (id: string,
               contentType: string,
               appLabel: string,
               offset: number,
               limit: number,
               data?: Object[]
    ) => Promise<Object>,
    data: Array<Object>,
    objectId: string,
    contentType: string,
    appLabel: string,
    limit: number,
    offset: number,
    next: string | null,
    callback?: (event: SyntheticMouseEvent<HTMLButtonElement>) => void,
    history: RouterHistory,
    match: Match
}

const locales = {
    close: (
        <FormattedMessage
            id="timeline.close"
            defaultMessage="Close"
        />
    ),
    timeline: (
        <FormattedMessage
            id="timeline.heading"
            defaultMessage="Timeline"
        />
    ),
};

const TIMELINE_KEY = 'TIMELINE_KEY';

const mapDispatchToProps = (dispatch) => (
    bindActionCreators(sidePanelActions, dispatch)
);

@withRouter
@connectAPI((apiClient: ApiClient) => ({
    getData: {
        send: (id: string,
            contentType: string,
            appLabel: string,
            offset: number,
            limit: number) => apiClient.resources.auditEvent.timeline(id, contentType, appLabel, offset, limit),
        success: (response: Object, id: string, contentType: string,
            appLabel, offset: number, limit: number, data = []) => ({
            data: [...data, ...response.data.results],
            limit: response.data.limit,
            offset: response.data.offset + response.data.limit, // offset for the next page
            next: response.data.next,
        }),
    },
}))
@connect(null, mapDispatchToProps)
class AuditEventTimeline extends React.PureComponent<Props> {
    componentDidMount() {
        const {
            objectId, getData, contentType, offset, limit, appLabel,
        } = this.props;

        if (getData) {
            getData(objectId, contentType, appLabel, offset, limit);
        }
    }

    handleOnMore = () => {
        const {
            next, getData, objectId, contentType, offset, limit, data, appLabel,
        } = this.props;

        if (getData && next) {
            getData(objectId, contentType, appLabel, offset, limit, data);
        }
    };

    handleClose = (event: SyntheticMouseEvent<HTMLButtonElement>) => {
        const {
            callback, history, match: { url }, closePanel,
        } = this.props;

        if (callback) {
            callback(event);
        } else {
            closePanel(TIMELINE_KEY);
            const nextPath = url.replace(/timeline\/.+$/, '');
            history.push(nextPath);
        }
    };

    render() {
        const { data, contentType, limit } = this.props;

        return (
            <SidePane id={TIMELINE_KEY} openInitially title={locales.timeline}>
                <Box height="100%" justify="between" pad={{ horizontal: 'medium', vertical: 'small' }}>
                    {isEmpty(data) ? (
                        <Box margin="small" align="center">
                            <span>
                                {' '}
                                <FormattedMessage id="timeline-no-info" defaultMessage="No Information" />
                                {' '}
                            </span>
                        </Box>
                    ) : (
                        <Box overflow="auto" height="90%">
                            <InfiniteScroll items={data} step={limit - 1} onMore={this.handleOnMore}>
                                {(item) => (
                                    <Box
                                        key={`${contentType}-timeline-${item.id}`}
                                        style={{ fontSize: '12px', minHeight: 'auto' }}
                                        margin={{ top: '3px' }}
                                    >
                                        <span dangerouslySetInnerHTML={{ __html: item.action_text }} />
                                        <TimelineDelimiter />
                                    </Box>
                                )}
                            </InfiniteScroll>
                        </Box>
                    )}
                    <GreenButton label={locales.close} onClick={this.handleClose} />
                </Box>
            </SidePane>
        );
    }
}
AuditEventTimeline.defaultProps = {
    getData: undefined,
    data: [],
    limit: 20,
    offset: 0,
    callback: undefined,
    history: {},
    next: null,
    match: {},
};
export default AuditEventTimeline;
